
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import * as animationData from '@/assets/json/loading.json'
import lottieThis from 'vue-lottie'
@Component({
  name: 'loadingLottie',
  components: { lottieThis },
})
export default class dataView extends Vue {
  @Prop({ default: '' }) setLoadingStyle?: string
  @Prop({ default: '' }) animTextStyle?: string
  @Prop({ default: '' }) lottieMiddleStyle?: string
  @Prop({ default: '加载中...' }) text?: string
  @Prop({ default: '' }) subText?: string
  @Prop() status!: number
  @Prop({ default: false }) cancelShow!: boolean
  defaultOptions = { animationData: animationData }
  animationSpeed = 1
  anim = {}
  handleAnimation(anim: any) {
    this.anim = anim
  }
  cancelLottie() {
    this.$emit('cancelVideo')
  }
}
